<template>
  <div id="dashboard">
    <Header />
    <div class="uk-card uk-padding uk-flex uk-flex-center uk-animation-fade" uk-height-viewport>
      <div class="uk-container uk-container">
        <div class="uk-grid-margin uk-grid uk-grid-stack" uk-grid>
          <div class="uk-width-auto" uk-scrollspy="cls: uk-animation-fade; repeat: true">
            <div
              class="uk-width-medium uk-card uk-card-primary uk-height-small uk-box-shadow-medium uk-border-rounded uk-card-hover"
            >
              <router-link to="/quotations">
                <h1
                  class="uk-text-center uk-text-middle uk-text-bolder uk-heading-small"
                >
                  <b>{{quotationCount}}</b>
                </h1>
                <h1
                  class="uk-text-center uk-text-middle uk-text-large uk-text-bolder uk-text-uppercase  uk-margin-remove-top"
                >
                  Devis
                </h1>
              </router-link>
            </div>
          </div>

          <div class="uk-width-auto" uk-scrollspy="cls: uk-animation-fade; repeat: true">
            <div
              class="uk-width-medium uk-card uk-card-primary uk-height-small uk-box-shadow-medium uk-border-rounded uk-card-hover"
            >
              <router-link to="/invoices">
                <h1
                  class="uk-text-center uk-text-middle uk-text-bolder uk-heading-small"
                >
                  <b>{{invoiceCount}}</b>
                </h1>
                <h1
                  class="uk-text-center uk-text-middle uk-text-large uk-text-bolder uk-text-uppercase uk-margin-remove-top"
                >Factures</h1>
              </router-link>
            </div>
          </div>
        </div>
        <router-link to="/create-document">
          <button
            class="uk-button uk-button-default uk-border-rounded uk-text-bold uk-margin-large-top"
          ><span class="uk-icon uk-margin-small-right" uk-icon="icon: plus-circle"></span>Nouveau document</button>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "../components/Header";
import QuotationStatus from "../enums/quotation-status";
import InvoiceStatus from "../enums/invoice-status";
import Quotation from "../models/quotation";
import Invoice from "../models/invoice";
import firebase from "firebase";
import UIkit from "uikit";

export default {
  name: "Login",
  components: {
    Header
  },
  data() {
    return {
      quotationCount: 0,
      invoiceCount: 0
    };
  },

  mounted() {
    const self = this;
    firebase
      .firestore()
      .collection("Invoices")
      .get()
      .then(querySnapshot => {
        var filtered = []
        querySnapshot.forEach(doc => {
          filtered.push(new Invoice(doc));
        });

        filtered = filtered.filter(function(doc) {
          console.log(doc.data.status)
          return doc.data.status !== undefined && doc.data.status === InvoiceStatus.INVOICED
        })
        self.invoiceCount = filtered.length;
      })
      .catch(function(error) {
        console.log("Error getting documents: ", error);
      });
    firebase
      .firestore()
      .collection("Quotations")
      .get()
      .then(querySnapshot => {
        var filtered = []
        querySnapshot.forEach(doc => {
          filtered.push(new Quotation(doc));
        });

        filtered = filtered.filter(function(doc) {
          return doc.data.status === undefined || doc.data.status !== QuotationStatus.DELETED
        })
        self.quotationCount = filtered.length;
      })
      .catch(function(error) {
        console.log("Error getting documents: ", error);
      });
  },

  methods: {
    signIn: function() {
      firebase
        .auth()
        .signInWithEmailAndPassword(this.email, this.password)
        .catch(function() {});
    },

    isEmail: function() {},

    displayErrorMessage: function() {
      UIkit.notification(
        "<span uk-icon='icon: warning'></span> Adresse email et/ou mot de passe incorrect.",
        { pos: "bottom-center", status: "danger" }
      );
    }
  }
};
</script>

<style scoped>
.uk-card-primary {
  background: linear-gradient(#2a93ac, #6a93ac);
}
</style>>